export const DESCRIPTION_LIMITS = {
    long: 750,
};
